/* eslint-disable */
import getModeReglement from '@/services/import/bailleur/parametrage/getModeReglement';
import getMotifBlocagePaiement from '@/services/import/bailleur/parametrage/getMotifBlocagePaiement';
import getCivilite from '@/services/import/bailleur/parametrage/getCivilites';
import genererBailleur from '@/services/import/bailleur/genererBailleur';
import { createAll } from '@/api/tiers/index';

export async function makeBailleurGenerated(lignes) {
  await getModeReglement(lignes.map((l => l.modeReglement)));
  await getMotifBlocagePaiement(lignes.map((l => l.motifBlocagePaiement)));
  await getCivilite(lignes.map((l => l.civilite)));

  const bailleurs = [];
  // récupérations des lignes à sauvegarder
  const lignesASauvegarder = [...new Set(lignes.filter((ligne) => ligne.typeBailleur !== 'Sauvage'))];

  // génération bailleur
  lignesASauvegarder.forEach((ligne) => {
    const bailleur = genererBailleur(ligne);
    bailleurs.push(bailleur);
  });
  return bailleurs;
}

export async function makeBailleurImport(bailleurs, modeTest) {
  await createAll(bailleurs, modeTest, true);
}
